import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页',
    component: Home
  },
  {
    path: '/about',
    name: '走进佳驰',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/news',
    name: '新闻中心',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/news.vue')
  },
  {
    path: '/news-detail',
    name: '新闻详情',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/newsdetail.vue'),
    meta:{
      hidden:true
    }
  },
  {
    path: '/product',
    name: '产品中心',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/product.vue'),
    children:[
      {
        path:'detail',
        name:"产品详情",
        component: () => import(/* webpackChunkName: "about" */ '../components/product/detail.vue'),
      }
    ]
  },
  {
    path: '/service',
    name: '服务能力',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/service.vue')
  },
  // {
  //   path: '/investorRelations',
  //   name: '投资者关系',
  //   component: () => import('../views/InvestorRelations.vue'),
  //   children: [
  //     {
  //       path: '',
  //       name: "投资者热线",
  //       component: () => import('../components/investorRelations/InvestorHotline.vue'),
  //     },
  //     {
  //       path: '/Announcements',
  //       name: "公告信息",
  //       component: () => import('../components/investorRelations/Announcements.vue')
  //     },
  //     {
  //       path: '/StockInfo',
  //       name: "股票信息",
  //       component: () => import('../components/investorRelations/StockInfo.vue')
  //     }
  //   ]
  // },
  {
    path: '/join',
    name: '加入我们',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/join.vue')
  },{
    path: '/contact',
    name: '联系我们',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/contact.vue')
  },{
    path: '/search',
    name: '搜索',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/search.vue'),
    meta:{
      hidden:true
    }
  },
]
routes.forEach((val, index) => {
  val.meta = val.meta || {}
  val.meta.id = index
  if (val.children) {
    val.children.forEach(val => {
      val.meta = val.meta || {}
      val.meta.id = index
    })
  }
})
const router = new VueRouter({
  routes
})
router.beforeEach((to,from,next)=>{
  window.scrollTo(0,0)
  next()
})
export default router
